import { render, staticRenderFns } from "./MainSubscribe.vue?vue&type=template&id=c3e4a280&"
import script from "./MainSubscribe.vue?vue&type=script&lang=js&"
export * from "./MainSubscribe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports